import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import { MonetizationType } from '@/@types/graphql-types';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'Rent',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = useLanguageStore();



const { getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return getInfoTextBlock(MonetizationType.Rent, 'Voit vuokrata elokuvan', 'netissä palvelussa');
		case 'ru':
			return getInfoTextBlock(MonetizationType.Rent, 'Вы можете взять', 'напрокат на', 'онлайн');
		case 'it':
			return getInfoTextBlock(MonetizationType.Rent, 'Puoi noleggiare', 'su', 'online');
		case 'de':
			return getInfoTextBlock(MonetizationType.Rent, 'Du kannst', 'bei', 'online ausleihen');
		case 'pt':
			return getInfoTextBlock(MonetizationType.Rent, 'Você pode assistir', 'no', 'e alugar online');
		case 'fr':
			return getInfoTextBlock(MonetizationType.Rent, 'En ce moment, vous pouvez louer', 'sur');
		case 'es':
			return getInfoTextBlock(MonetizationType.Rent, 'Actualmente, usted es capaz de alquilar', 'en', 'online');
		case 'ja':
			return getOfferTextBlock(MonetizationType.Rent, 'で配信版のレンタルができます');
		case 'ko':
			return getOfferTextBlock(MonetizationType.Rent, '현재 ', `에서 "${props.title}" 대여가 가능합니다.`);
		case 'ro':
			return getInfoTextBlock(MonetizationType.Rent, 'Puteți închiria', 'pe', 'online');
		case 'hu':
			return getInfoTextBlock(MonetizationType.Rent, 'A(z)', 'online kibérelhető itt:');
		case 'cs':
			return getInfoTextBlock(MonetizationType.Rent, 'Si můžete půjčit', 'u', 'online');
		case 'bg':
			return getInfoTextBlock(MonetizationType.Rent, 'Можете да наемете', 'в', 'онлайн');
		case 'ar':
			return getInfoTextBlock(MonetizationType.Rent, 'بإمكانكم أيضاً تأجير', 'على', 'أونلاين');
		case 'pt':
			return getInfoTextBlock(MonetizationType.Rent, 'Você pode alugar', 'online via');
		case 'tr':
			return getInfoTextBlock(
				MonetizationType.Rent,
				'',
				'adlı yapımı',
				'üzerinden çevrimiçi olarak kiralayabilirsiniz'
			);
		case 'sq':
			return getInfoTextBlock(MonetizationType.Rent, 'Ju mund ta merrni', 'me qira në', 'online');
		case 'pl':
			return getInfoTextBlock(MonetizationType.Rent, 'Możesz wypożyczyć', 'online w serwisie');
		case 'ro':
			return getInfoTextBlock(MonetizationType.Rent, 'Poți închiria online', 'pe');
		case 'az':
			return getInfoTextBlock(MonetizationType.Rent, '', 'filmini', 'saytında onlayn icarəyə götürə bilərsiniz');
		case 'el':
			return getInfoTextBlock(MonetizationType.Rent, 'Μπορείτε να ενοικιάσετε τον τίτλο', 'στο', 'online');
		case 'sr':
			return getInfoTextBlock(MonetizationType.Rent, 'Možete da iznajmite', 'na', 'onlajn');
		case 'sv':
			return getInfoTextBlock(MonetizationType.Rent, 'Du kan hyra', 'på', 'online');
		case 'uk':
			return getInfoTextBlock(MonetizationType.Rent, 'Ви також можете взяти', 'напрокат онлайн на');
		case 'ur':
			return getRTLInfoTextBlock(MonetizationType.Rent, 'آپ آن لائن', 'پر', 'کرائے پر لے سکتے ہیں۔');
		case 'zh':
			return getRTLInfoTextBlock(MonetizationType.Rent, '你可以在', '在线租赁');
		case 'en':
		default:
			return getInfoTextBlock(MonetizationType.Rent, 'You can rent', 'on', 'online');
	}
});

return { __sfc: true,language, props, getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock, text }
}

})